import { defineComponent as _defineComponent } from 'vue'
import SelectBoxOption from '@/assets/js/models/SelectBoxOption';
import Dropdown from '@/modules/shared/components/util/Dropdown.vue';
import { computed, ref, watch, withDefaults, onMounted } from 'vue';

type Props = {
    value?: any;
    options?: SelectBoxOption[];
    placeholder?: string;
    disabled?: boolean|string;
}
type Emits = {
    (e: 'input', value: any): void;
    (e: 'change', value: any): void;
    (e: 'update:modelValue', value: any): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBox',
  props: {
    value: { default: null },
    options: { default: () => [] },
    placeholder: { default: '' },
    disabled: { type: [Boolean, String], default: false }
  },
  emits: ["input", "change", "update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'input', value: any): void;
    (e: 'change', value: any): void;
    (e: 'update:modelValue', value: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any, options: SelectBoxOption[], placeholder: string, disabled: boolean|string };





const wrapper = ref<HTMLElement|null>(null);
const selectedOption = ref<SelectBoxOption|null>(null);
const showDropdown = ref<boolean>(false);

const isDisabled = computed<boolean>(() => props.disabled === true || props.disabled === 'true' || props.options.length === 0);
const displayName = computed<string>(() => {
    if (selectedOption.value) {
        return selectedOption.value.displayName;
    }
    return '';
});

function onValueChanged() {
    if (props.value === null || props.value === undefined) {
        // null and undefined are treated as the same "empty" value, so options like "all categories" stay selectable
        selectedOption.value = props.options.find((option) => option.value === null || option.value === undefined) || null;
    } else if (typeof props.value === 'object') {
        const valueStr = JSON.stringify(props.value);
        selectedOption.value = props.options.find((option) => JSON.stringify(option.value) === valueStr) || null;
    } else {
        selectedOption.value = props.options.find((option) => option.value === props.value) || null;
    }
}

watch([() => props.value, () => props.options], () => onValueChanged());

function toggleDropdown(show?: boolean) {
    if (isDisabled.value) {
        showDropdown.value = false;
    } else if (show !== undefined) {
        showDropdown.value = show;
    } else {
        showDropdown.value = !showDropdown.value;
    }
}

function selectOption(option: SelectBoxOption): void {
    showDropdown.value = false;
    if (props.value !== option.value) {
        selectedOption.value = option;
        emits('input', option.value);
        emits('change', option.value);
        emits('update:modelValue', option.value);
    }
}

onMounted(() => {
    onValueChanged();
});

return { __sfc: true,props, emits, wrapper, selectedOption, showDropdown, isDisabled, displayName, onValueChanged, toggleDropdown, selectOption, Dropdown }
}

})